import { createStandardAction } from 'typesafe-actions';
import { AxiosRequestConfig } from 'axios';

const API_SEND_REQUEST_START = 'API_SEND_REQUEST_START';
const API_SEND_REQUEST_SUCCESS = 'API_SEND_REQUEST_SUCCESS';
const API_SEND_REQUEST_ERROR = 'API_SEND_REQUEST_ERROR';

export const startSendApiRequest = createStandardAction(API_SEND_REQUEST_START)<AxiosRequestConfig>();
export const startSendApiSuccess = createStandardAction(API_SEND_REQUEST_SUCCESS)<object, object>();
export const startSendApiError = createStandardAction(API_SEND_REQUEST_ERROR)<object, object>();



// WEBPACK FOOTER //
// ./src/modules/api/actions.ts